import { BaseAxios, throwErrorResponse } from 'src/common/services/axios';
import { flatten } from 'src/lib/axios';
import { PartnerDTO } from 'src/common/models/partner';

export const getPartner = (partnerCode: string) =>
  BaseAxios.get<PartnerDTO>(`/api/partners/codes/${partnerCode}`)
    .then(flatten)
    .catch(throwErrorResponse);
